export enum FormResponse {
  Success = 'success',
  Fail = 'fail',
}
